<template>
    <div class="account">
        <AccountContainer
            @profileClick="onProfileClick"
        />
        <router-link
            :to="{ name: routeNames.deposit }"
            tag="button"
            class="btn btn--md btn--w-144 btn__primary--yellow"
        >
            {{ $t('deposit') | capitalize }}
        </router-link>
    </div>
</template>

<script>
    import { routeNames } from '@app/router';
    import AccountContainer from '@app/shared/components/Account/AccountContainer';

    export default {
        name: 'UserBar',
        props: {
            user: {
                type: Object,
                required: true
            }
        },
        created() {
            this.routeNames = routeNames;
        },
        methods: {
            onProfileClick() {
                this.$router.push({ name: routeNames.profile });
            },
        },
        components: {
            AccountContainer,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/authentication/components/UserBar.vue